import React, { useContext } from "react";
import { context } from "../App";

function Alerts() {
  const { alert, setAlert } = useContext(context);
  const alertStates = ["good", "bad", "warning", "normal"];

  const classes = [
    "flex items-center p-4 mb-4 text-sm text-green-800 bg-green-50",
    "flex items-center p-4 mb-4 text-sm text-red-800 bg-red-50",
    "flex items-center p-4 mb-4 text-sm text-yellow-800 bg-yellow-50",
    "flex items-center p-4 mb-4 text-sm text-blue-800 bg-blue-50",
  ];

  const getClassForAlert = (alertType) => {
    const index = alertStates.indexOf(alertType);
    return index !== -1 ? classes[index] : "flex items-center p-4 mb-4 text-sm text-blue-800 bg-blue-50";
  };

  return (
    <div>

      { (alert.isOpen && ((alert.message).length > 3)) && (<div
        class={getClassForAlert(alert.type)}
        role="alert"
     >
        <span class="sr-only">Info</span>
        <div>
          <span class="font-medium">{alert.message}</span> 
          {alert.description}
        </div>
      </div>)}


    </div>
  );
}

export default Alerts;
